import React from "react"
import { Wrapper, Desktop, Mobile } from "./FooterHeroImageStyles"

export const FooterHeroImage = () => {
    return (
      <Wrapper>
          <Desktop>
            <img src={"https://cdn.sanity.io/images/c4rhoo6t/production/9b4ada93f2c7f323fd91fb2095596eb1ae07dbe7-3370x558.png"} alt={"Driza-Bone"} loading={"lazy"}/>
          </Desktop>
          <Mobile>
              <img 
                src={"https://cdn.sanity.io/images/c4rhoo6t/production/0feea3e9f9ae566131fdbb589f7a21ad82b21cfd-2588x512.png"}
                alt={"Driza-Bone"}
                loading={"lazy"}
              />
          </Mobile>
      </Wrapper>
    )
}